import { Navigate, useLocation, useParams } from "react-router-dom"

/**
 * Redirects a legacy module path (and all of its sub-paths — case pages, chat,
 * nested projects) to the module's current configured path, preserving query
 * string and hash. Mount under a trailing-splat route, e.g. `/anbud/*`.
 */
export function LegacyPathRedirect({ to }: { to: string }) {
  const params = useParams()
  const location = useLocation()
  const splat = params["*"]
  return (
    <Navigate
      replace
      to={{
        pathname: splat ? `${to}/${splat}` : to,
        search: location.search,
        hash: location.hash,
      }}
    />
  )
}
